import { z } from 'zod';

export const FilterSchema = z.object({
    filter: z.object({
        property_id: z.string(),
        base_on: z.string(),
        start_date: z.string(),
        end_date: z.string(),
        room_type_id: z.string().optional(),
    }),
});

export type FilterSchemaType = z.infer<typeof FilterSchema>;
